import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  AlertHistoryResponse,
  ApiResponse,
  SpringPage,
} from '../models/notification.model';

/**
 * Thin REST client for the alert/notification endpoints exposed by the
 * notification service through the API gateway.
 *
 * Base path: `${apiURL}/notification/api/v1/alerts`
 */
@Injectable({ providedIn: 'root' })
export class NotificationApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiURL}/notification/api/v1/alerts`;

  getNotifications(
    userId: string,
    page = 0,
    size = 20
  ): Observable<SpringPage<AlertHistoryResponse>> {
    const params = new HttpParams()
      .set('userId', userId)
      .set('page', page)
      .set('size', size)
      .set('sort', 'triggeredAt,desc');
    return this.http
      .get<ApiResponse<SpringPage<AlertHistoryResponse>>>(
        `${this.baseUrl}/notifications`,
        { params }
      )
      .pipe(map((r) => r.data));
  }

  countUnread(userId: string): Observable<number> {
    const params = new HttpParams().set('userId', userId);
    return this.http
      .get<ApiResponse<number>>(`${this.baseUrl}/notifications/count`, {
        params,
      })
      .pipe(map((r) => r.data));
  }

  markAsRead(id: string, userId: string): Observable<void> {
    const params = new HttpParams().set('userId', userId);
    return this.http
      .patch<ApiResponse<void>>(
        `${this.baseUrl}/notifications/${id}/read`,
        null,
        { params }
      )
      .pipe(map(() => void 0));
  }

  markAllAsRead(userId: string): Observable<number> {
    const params = new HttpParams().set('userId', userId);
    return this.http
      .patch<ApiResponse<number>>(
        `${this.baseUrl}/notifications/read-all`,
        null,
        { params }
      )
      .pipe(map((r) => r.data));
  }
}
